exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Canvas_footer_uX-BG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-size:12px;margin-top:20px}.Canvas_footerButton_CAMBk{display:inline-block;cursor:pointer;color:#549bd4;margin-left:20px;-webkit-transition:.2s;transition:.2s}.Canvas_footerButton_CAMBk:hover{color:#28608f}", ""]);

// exports
exports.locals = {
	"footer": "Canvas_footer_uX-BG",
	"footerButton": "Canvas_footerButton_CAMBk"
};